import React, { useEffect } from 'react';
import Animated from 'components/generals/AnimatedComponent';
import pictures from 'assets/images/home/section_8/pictures.png';
import ActionButton from 'components/ui/buttons/action-button';
import { Link } from 'react-router-dom';

export default function Home__section__8() {
    return (
        <main className="nv__section nv__section--no-margin nv__hp__section__8">
            <section className="nv__section__container">
                <Animated animation={'animate__fadeInDown animate__delay-1s'}>
                    <h1>
                        ¡Únete al Futuro de <br />
                        la Agricultura Mexicana!
                    </h1>
                </Animated>

                <Animated animation={'animate__fadeInDown animate__delay-2s'}>
                    <p>
                        Una demanda en aumento y una producción que necesita expandirse para
                        satisfacerla. Esta es la situación actual en el campo mexicano y representa
                        una oportunidad única y benéfica.
                    </p>
                </Animated>

                <Animated animation={'animate__fadeInDown animate__delay-3s'}>
                    <p>
                        La necesidad de expandir nuestra producción no solo es una realidad, sino
                        también una puerta abierta a un futuro próspero en la industria agrícola.
                        ¿No crees que esta sea una oportunidad que merezca tu atención? Estamos
                        listos para actuar de inmediato, expandiendo nuestras operaciones para
                        aprovechar al máximo este mercado en crecimiento.
                    </p>
                </Animated>

                <Animated animation={'animate__fadeInDown animate__delay-4s'}>
                    <Link to="https://wa.me/5215531151431" target="_blank">
                        <ActionButton
                            text={'Me gustaría ser parte'}
                            type="rounded"
                            color="black"
                            onClick={() => {
                                // dispatch(setDisplayModal(true));
                            }}
                        />
                    </Link>
                </Animated>

                <Animated animation={'animate__fadeIn animate__delay-5s'}>
                    <img src={pictures} alt="pictures" />
                </Animated>
            </section>
        </main>
    );
}
